import { render, staticRenderFns } from "./LmsCheckoutSuccess.vue?vue&type=template&id=2a6ea16c&scoped=true"
import script from "./LmsCheckoutSuccess.vue?vue&type=script&lang=js"
export * from "./LmsCheckoutSuccess.vue?vue&type=script&lang=js"
import style0 from "./LmsCheckoutSuccess.vue?vue&type=style&index=0&id=2a6ea16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ea16c",
  null
  
)

export default component.exports